document.addEventListener('DOMContentLoaded', function () {
	var skipLink = document.querySelector('[data-skip-content]');
	if (!skipLink) return;

	skipLink.addEventListener('click', function (event) {
		event.preventDefault();

		var target = document.getElementById(skipLink.hash.slice(1));
		if (!target) return;

		var savedTabIndex = target.getAttribute('tabindex');
		target.setAttribute('tabindex', '-1');
		target.focus();

		target.addEventListener('blur', function handleBlur() {
			target.removeEventListener('blur', handleBlur);
			if (savedTabIndex === null) {
				target.removeAttribute('tabindex');
			} else {
				target.setAttribute('tabindex', savedTabIndex);
			}
		});
	});
});